<svg class="mark light" viewBox="0 0 18 18" fill="none">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.5745 5.82918C13.5503 5.82918 14.4522 6.05543 15.1838 6.43869C15.5537 5.25304 15.3998 4.08899 14.6564 3.34551C13.9129 2.60201 12.7488 2.44816 11.5631 2.81804C11.9452 3.549 12.1707 4.44962 12.1707 5.42374C12.1707 5.56518 12.166 5.70508 12.1567 5.84313C12.2942 5.8339 12.4336 5.82918 12.5745 5.82918Z"
    fill="#D176C7"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.34314 3.3415C4.08686 2.59777 5.25144 2.44405 6.43749 2.81438C6.05502 3.54554 5.82929 4.44658 5.82929 5.42121C5.82929 5.56266 5.83404 5.70256 5.84334 5.84061C5.70578 5.83138 5.56639 5.82666 5.42546 5.82666C4.44972 5.82666 3.54773 6.0529 2.81612 6.43617C2.44567 5.25001 2.59934 4.08529 3.34314 3.3415Z"
    fill="#EC80BC"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.5745 12.169C12.4336 12.169 12.2942 12.1643 12.1567 12.1551C12.166 12.2931 12.1707 12.433 12.1707 12.5744C12.1707 13.55 11.9446 14.4518 11.5614 15.1833C12.7479 15.554 13.9129 15.4005 14.6568 14.6565C15.401 13.9123 15.5545 12.7467 15.1832 11.5598C14.4517 11.9429 13.55 12.169 12.5745 12.169Z"
    fill="#9C73D1"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.4647 9.00073C13.5684 9.09134 13.6701 9.18643 13.7696 9.28593C14.4591 9.97546 14.9368 10.7727 15.1832 11.5605C16.2846 10.9838 17 10.0513 17 8.99902C17 7.94697 16.2848 7.01459 15.1839 6.43782C14.9377 7.22682 14.4597 8.02539 13.7691 8.71595C13.6698 8.81529 13.5682 8.91024 13.4647 9.00073Z"
    fill="#AF7BD2"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.43749 2.81424C7.01416 1.71183 7.94716 0.995604 9 0.995604C10.0532 0.995604 10.9865 1.71232 11.5631 2.81538C10.7741 3.06151 9.97557 3.53955 9.28503 4.23009C9.18574 4.32938 9.09084 4.43091 9.00039 4.53432C8.90955 4.4304 8.81422 4.32837 8.71445 4.22861C8.02424 3.53839 7.22612 3.06047 6.43749 2.81424Z"
    fill="#EB85C1"
  />
  <path
    d="M9.00039 4.53432C8.49719 5.10963 8.13177 5.74324 7.91405 6.37496C7.76189 6.81646 7.68188 7.25704 7.67741 7.67616C7.96071 7.67325 8.23419 7.70488 8.49151 7.77207C8.66946 7.81855 8.83969 7.88204 9.00008 7.96289C9.16045 7.88211 9.33065 7.81868 9.50857 7.77226C9.76572 7.70517 10.039 7.6736 10.3221 7.67651C10.3178 7.25731 10.238 6.8166 10.0859 6.37495C9.86848 5.74328 9.50331 5.10968 9.00039 4.53432Z"
    fill="#E251A6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.3221 7.67893C10.325 7.96232 10.2933 8.23589 10.226 8.49327C10.1796 8.67098 10.1161 8.84096 10.0354 9.00114C10.1157 9.16058 10.1788 9.32973 10.2251 9.50652C10.2928 9.7649 10.3246 10.0396 10.3216 10.3242C10.7407 10.3199 11.1812 10.2401 11.6227 10.0881C12.2549 9.87045 12.889 9.50489 13.4647 9.00136C12.8885 8.49751 12.2538 8.13185 11.6212 7.91436C11.1804 7.76282 10.7405 7.68322 10.3221 7.67893Z"
    fill="#9151C4"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.49261 10.2246C8.6695 10.1784 8.83875 10.1153 8.99829 10.0351C9.15859 10.116 9.32873 10.1795 9.50659 10.226C9.76417 10.2934 10.038 10.3251 10.3216 10.3222C10.3172 10.7402 10.2375 11.1796 10.0861 11.62C9.8687 12.2524 9.5032 12.8869 8.99961 13.4629C8.49615 12.8869 8.13074 12.2526 7.91336 11.6202C7.76175 11.1793 7.68214 10.7392 7.67789 10.3207C7.96142 10.3236 8.23512 10.2919 8.49261 10.2246Z"
    fill="#5C09A0"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.1567 5.84259C12.1053 6.60609 11.9149 7.31317 11.6212 7.91406C11.1804 7.76253 10.7405 7.68292 10.3221 7.67863C10.3179 7.25943 10.238 6.81873 10.086 6.37707C10.6868 6.08383 11.3936 5.8938 12.1567 5.84259Z"
    fill="#CE51AE"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.0004 4.53631C8.4972 5.11162 8.13177 5.74523 7.91405 6.37695C7.31326 6.0837 6.60646 5.89367 5.84335 5.84246C5.83405 5.70441 5.8293 5.56452 5.8293 5.42307C5.8293 4.44844 6.05503 3.5474 6.4375 2.81623C7.22613 3.06247 8.02425 3.54039 8.71446 4.2306C8.81423 4.33037 8.90956 4.43239 9.0004 4.53631Z"
    fill="#E55FAD"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.5631 2.81738C11.9452 3.54834 12.1707 4.44896 12.1707 5.42308C12.1707 5.56452 12.166 5.70442 12.1567 5.84247C11.3936 5.89367 10.6868 6.0837 10.086 6.37695C9.86849 5.74528 9.50332 5.11168 9.0004 4.53632C9.09085 4.43291 9.18575 4.33139 9.28504 4.23209C9.97558 3.54155 10.7741 3.06351 11.5631 2.81738Z"
    fill="#DD5CB0"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.4647 9C12.8885 8.49615 12.2538 8.13049 11.6212 7.913C11.9149 7.31211 12.1053 6.60502 12.1567 5.84153C12.2942 5.8323 12.4336 5.82758 12.5745 5.82758C13.5502 5.82758 14.4522 6.05383 15.1838 6.43709C14.9377 7.2261 14.4597 8.02467 13.7691 8.71522C13.6698 8.81456 13.5682 8.90951 13.4647 9Z"
    fill="#A152C1"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.1567 12.156C12.1053 11.3938 11.9155 10.6879 11.6227 10.0876C12.2549 9.87 12.889 9.50444 13.4647 9.00091C13.5683 9.09153 13.6701 9.18661 13.7696 9.28611C14.4591 9.97564 14.9368 10.7729 15.1832 11.5607C14.4517 11.9438 13.55 12.1699 12.5745 12.1699C12.4336 12.1699 12.2942 12.1652 12.1567 12.156Z"
    fill="#9151C4"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.6227 10.0879C11.9155 10.6881 12.1053 11.3941 12.1567 12.1562C11.3936 12.1051 10.6869 11.9151 10.0861 11.6219C10.2375 11.1815 10.3171 10.7421 10.3216 10.324C10.7407 10.3198 11.1812 10.2399 11.6227 10.0879Z"
    fill="#6C1EAB"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.37862 7.91347C5.74609 8.13086 5.11155 8.49637 4.53542 9C4.43173 8.90934 4.32993 8.81421 4.23038 8.71466C3.54026 8.02454 3.06238 7.22654 2.81612 6.43802C3.54773 6.05475 4.44972 5.8285 5.42546 5.8285C5.56639 5.8285 5.70578 5.83322 5.84334 5.84245C5.89475 6.60575 6.08506 7.31267 6.37862 7.91347Z"
    fill="#DF63B2"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.37861 7.91344C6.81933 7.76197 7.25907 7.6824 7.6774 7.67811C7.67438 7.96179 7.70596 8.23563 7.7732 8.49327C7.81962 8.67113 7.88304 8.84127 7.96379 9.00158C7.88373 9.16069 7.82075 9.32945 7.7745 9.50584C7.70684 9.76382 7.67498 10.0381 7.67786 10.3223C7.25914 10.318 6.81897 10.2383 6.37783 10.0865C5.74555 9.86899 5.11129 9.5035 4.53542 8.99998C5.11155 8.49634 5.74609 8.13084 6.37861 7.91344Z"
    fill="#E251A6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.91405 6.37754C7.76189 6.81904 7.68188 7.25962 7.67741 7.67873C7.25908 7.68302 6.81934 7.76259 6.37862 7.91406C6.08506 7.31327 5.89475 6.60635 5.84334 5.84305C6.60645 5.89425 7.31325 6.08429 7.91405 6.37754Z"
    fill="#E156AA"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.49151 7.77431C8.2342 7.70711 7.96072 7.67549 7.67741 7.6784C7.67439 7.96207 7.70597 8.23591 7.77321 8.49355C7.81963 8.67141 7.88305 8.84155 7.9638 9.00186C7.88375 9.16097 7.82076 9.32974 7.77451 9.50612C7.70685 9.7641 7.67499 10.0384 7.67787 10.3225C7.9614 10.3255 8.2351 10.2938 8.49259 10.2265C8.66948 10.1802 8.83874 10.1172 8.99827 10.037C9.15858 10.1178 9.32871 10.1814 9.50657 10.2279C9.76415 10.2952 10.0379 10.3269 10.3216 10.324C10.3246 10.0394 10.2928 9.76472 10.2251 9.50634C10.1788 9.32955 10.1157 9.1604 10.0354 9.00096C10.1161 8.84078 10.1796 8.67079 10.226 8.49309C10.2933 8.23571 10.325 7.96214 10.3221 7.67874C10.039 7.67584 9.76572 7.70741 9.50858 7.7745C9.33065 7.82092 9.16046 7.88435 9.00008 7.96513C8.83969 7.88427 8.66947 7.82078 8.49151 7.77431Z"
    fill="#E251A6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.22991 9.28585C3.54036 9.9754 3.06269 10.7727 2.81625 11.5605C1.71519 10.9838 1 10.0514 1 8.99929C1 7.94724 1.71514 7.01486 2.81613 6.43809C3.06239 7.22661 3.54028 8.02461 4.2304 8.71473C4.32995 8.81428 4.43175 8.90941 4.53544 9.00007C4.43158 9.09086 4.32962 9.18614 4.22991 9.28585Z"
    fill="#E589C6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.37786 10.0865C6.08473 10.687 5.89472 11.3933 5.84336 12.156C5.7058 12.1652 5.56641 12.1699 5.42548 12.1699C4.44979 12.1699 3.54784 11.9437 2.81625 11.5605C3.0627 10.7726 3.54036 9.97532 4.22991 9.28577C4.32962 9.18606 4.43158 9.09078 4.53544 8.99999C5.11132 9.50351 5.74557 9.86901 6.37786 10.0865Z"
    fill="#C855B6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.42547 12.169C5.5664 12.169 5.70579 12.1643 5.84335 12.1551C5.83405 12.2931 5.8293 12.433 5.8293 12.5744C5.8293 13.5498 6.05536 14.4514 6.43835 15.1829C5.25183 15.5537 4.08666 15.4002 3.34266 14.6562C2.59846 13.912 2.44502 12.7464 2.81625 11.5595C3.54784 11.9428 4.44978 12.169 5.42547 12.169Z"
    fill="#9F4FC9"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.37786 10.0868C6.81899 10.2385 7.25916 10.3183 7.67788 10.3226C7.68213 10.7411 7.76174 11.1811 7.91335 11.6221C7.3127 11.9152 6.60616 12.1051 5.84335 12.1562C5.89471 11.3936 6.08473 10.6873 6.37786 10.0868Z"
    fill="#7D20A7"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.84335 12.1558C6.60616 12.1046 7.31271 11.9147 7.91335 11.6216C8.13073 12.254 8.49614 12.8883 8.9996 13.4643C8.90886 13.5681 8.81363 13.67 8.71398 13.7696C8.02416 14.4595 7.22655 14.9372 6.43835 15.1836C6.05537 14.4521 5.8293 13.5505 5.8293 12.5751C5.8293 12.4337 5.83406 12.2938 5.84335 12.1558Z"
    fill="#701EAD"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.28552 13.7694C9.97543 14.4593 10.7732 14.9371 11.5614 15.1834C10.9847 16.2847 10.0522 17 9.00001 17C7.94768 17 7.01508 16.2845 6.43834 15.183C7.22654 14.9366 8.02415 14.4589 8.71397 13.769C8.81362 13.6694 8.90885 13.5675 8.99959 13.4637C9.09043 13.5676 9.18575 13.6696 9.28552 13.7694Z"
    fill="#8D53BD"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.9996 13.4639C9.50319 12.8878 9.86869 12.2534 10.0861 11.6209C10.6869 11.9142 11.3936 12.1041 12.1567 12.1553C12.166 12.2934 12.1707 12.4333 12.1707 12.5747C12.1707 13.5502 11.9446 14.4521 11.5615 15.1836C10.7732 14.9373 9.97543 14.4595 9.28552 13.7696C9.18576 13.6698 9.09043 13.5678 8.9996 13.4639Z"
    fill="#6F29AF"
  />
  <path
    d="M9.00012 2.53711C9.00023 6.09382 11.9432 8.95657 15.4643 9.00127C11.8943 9.00133 9.00018 11.8954 9.00012 15.4654C9.00007 11.8954 6.10595 9.00138 2.53596 9.00127C6.10592 9.00115 9.00002 6.10707 9.00012 2.53711Z"
    fill="white"
  />
</svg>
<svg class="mark dark" viewBox="0 0 18 18" fill="none">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.5745 5.82918C13.5503 5.82918 14.4522 6.05543 15.1838 6.43869C15.5537 5.25304 15.3998 4.08899 14.6564 3.34551C13.9129 2.60201 12.7488 2.44816 11.5631 2.81804C11.9452 3.549 12.1707 4.44962 12.1707 5.42374C12.1707 5.56518 12.166 5.70508 12.1567 5.84313C12.2942 5.8339 12.4336 5.82918 12.5745 5.82918Z"
    fill="#BE6EC8"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.34314 3.3415C4.08686 2.59777 5.25144 2.44405 6.43749 2.81438C6.05502 3.54554 5.82929 4.44658 5.82929 5.42121C5.82929 5.56266 5.83404 5.70256 5.84334 5.84061C5.70578 5.83138 5.56639 5.82666 5.42546 5.82666C4.44972 5.82666 3.54773 6.0529 2.81612 6.43617C2.44567 5.25001 2.59934 4.08529 3.34314 3.3415Z"
    fill="#D66AB3"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.5745 12.169C12.4336 12.169 12.2942 12.1643 12.1567 12.1551C12.166 12.2931 12.1707 12.433 12.1707 12.5744C12.1707 13.55 11.9446 14.4518 11.5614 15.1833C12.7479 15.554 13.9129 15.4005 14.6568 14.6565C15.401 13.9123 15.5545 12.7467 15.1832 11.5598C14.4517 11.9429 13.55 12.169 12.5745 12.169Z"
    fill="#8A63C7"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.4647 9.00073C13.5683 9.09134 13.6701 9.18643 13.7696 9.28593C14.4591 9.97546 14.9368 10.7727 15.1832 11.5605C16.2846 10.9838 17 10.0513 17 8.99902C17 7.94697 16.2848 7.01459 15.1838 6.43782C14.9377 7.22682 14.4597 8.02539 13.7691 8.71595C13.6698 8.81529 13.5682 8.91024 13.4647 9.00073Z"
    fill="#8D66CA"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.43749 2.81424C7.01416 1.71183 7.94716 0.995604 9 0.995604C10.0532 0.995604 10.9865 1.71232 11.5631 2.81538C10.7741 3.06151 9.97557 3.53955 9.28503 4.23009C9.18574 4.32938 9.09084 4.43091 9.00039 4.53432C8.90955 4.4304 8.81422 4.32837 8.71445 4.22861C8.02424 3.53839 7.22612 3.06047 6.43749 2.81424Z"
    fill="#D475C0"
  />
  <path
    d="M9.00038 4.53432C8.49718 5.10963 8.13175 5.74324 7.91403 6.37496C7.76187 6.81646 7.68186 7.25704 7.67739 7.67616C7.9607 7.67325 8.23418 7.70488 8.49149 7.77207C8.66945 7.81855 8.83967 7.88204 9.00006 7.96289C9.16044 7.88211 9.33063 7.81868 9.50856 7.77226C9.7657 7.70517 10.039 7.6736 10.3221 7.67651C10.3178 7.25731 10.238 6.8166 10.0859 6.37495C9.86846 5.74328 9.50329 5.10968 9.00038 4.53432Z"
    fill="#E251A6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.3221 7.67893C10.325 7.96232 10.2933 8.23589 10.226 8.49327C10.1796 8.67098 10.1161 8.84096 10.0354 9.00114C10.1157 9.16058 10.1788 9.32973 10.2251 9.50652C10.2928 9.7649 10.3246 10.0396 10.3216 10.3242C10.7407 10.3199 11.1812 10.2401 11.6227 10.0881C12.2549 9.87045 12.889 9.50489 13.4647 9.00136C12.8885 8.49751 12.2538 8.13185 11.6212 7.91436C11.1804 7.76282 10.7405 7.68322 10.3221 7.67893Z"
    fill="#9151C4"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.49259 10.2246C8.66949 10.1784 8.83874 10.1153 8.99828 10.0351C9.15858 10.116 9.32871 10.1795 9.50657 10.226C9.76416 10.2934 10.0379 10.3251 10.3216 10.3222C10.3171 10.7402 10.2375 11.1796 10.0861 11.62C9.86869 12.2524 9.50319 12.8869 8.9996 13.4629C8.49614 12.8869 8.13073 12.2526 7.91334 11.6202C7.76174 11.1793 7.68212 10.7392 7.67788 10.3207C7.96141 10.3236 8.2351 10.2919 8.49259 10.2246Z"
    fill="#5C09A0"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.1567 5.84259C12.1053 6.60609 11.9149 7.31317 11.6212 7.91406C11.1804 7.76253 10.7405 7.68292 10.3221 7.67863C10.3179 7.25943 10.238 6.81873 10.086 6.37707C10.6868 6.08383 11.3936 5.8938 12.1567 5.84259Z"
    fill="#B941A2"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.0004 4.53631C8.4972 5.11162 8.13177 5.74523 7.91405 6.37695C7.31326 6.0837 6.60646 5.89367 5.84335 5.84246C5.83405 5.70441 5.8293 5.56452 5.8293 5.42307C5.8293 4.44844 6.05503 3.5474 6.4375 2.81623C7.22613 3.06247 8.02425 3.54039 8.71446 4.2306C8.81423 4.33037 8.90956 4.43239 9.0004 4.53631Z"
    fill="#CD53A3"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.5631 2.81738C11.9452 3.54834 12.1707 4.44896 12.1707 5.42308C12.1707 5.56452 12.166 5.70442 12.1567 5.84247C11.3936 5.89367 10.6867 6.0837 10.0859 6.37695C9.86847 5.74528 9.5033 5.11168 9.00038 4.53632C9.09083 4.43291 9.18573 4.33139 9.28502 4.23209C9.97556 3.54155 10.7741 3.06351 11.5631 2.81738Z"
    fill="#C74FA6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.4647 9C12.8885 8.49615 12.2538 8.13049 11.6212 7.913C11.9148 7.31211 12.1052 6.60502 12.1567 5.84153C12.2942 5.8323 12.4336 5.82758 12.5745 5.82758C13.5502 5.82758 14.4522 6.05383 15.1838 6.43709C14.9377 7.2261 14.4596 8.02467 13.7691 8.71522C13.6697 8.81456 13.5682 8.90951 13.4647 9Z"
    fill="#AC65D0"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.1567 12.156C12.1053 11.3938 11.9155 10.6879 11.6227 10.0876C12.2549 9.87 12.889 9.50444 13.4647 9.00091C13.5683 9.09153 13.6701 9.18661 13.7696 9.28611C14.4591 9.97564 14.9368 10.7729 15.1832 11.5607C14.4517 11.9438 13.55 12.1699 12.5745 12.1699C12.4336 12.1699 12.2942 12.1652 12.1567 12.156Z"
    fill="#8857BB"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.6227 10.0879C11.9155 10.6881 12.1053 11.3941 12.1567 12.1562C11.3936 12.1051 10.6869 11.9151 10.0861 11.6219C10.2375 11.1815 10.3171 10.7421 10.3216 10.324C10.7407 10.3198 11.1812 10.2399 11.6227 10.0879Z"
    fill="#996ED5"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.37863 7.91347C5.74611 8.13086 5.11157 8.49637 4.53544 9C4.43175 8.90934 4.32995 8.81421 4.2304 8.71466C3.54028 8.02454 3.0624 7.22654 2.81613 6.43802C3.54774 6.05475 4.44973 5.8285 5.42547 5.8285C5.5664 5.8285 5.70579 5.83322 5.84335 5.84245C5.89476 6.60575 6.08507 7.31267 6.37863 7.91347Z"
    fill="#CC53A5"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.37863 7.91344C6.81935 7.76197 7.25909 7.6824 7.67742 7.67811C7.67439 7.96179 7.70597 8.23563 7.77322 8.49327C7.81964 8.67113 7.88305 8.84127 7.96381 9.00158C7.88375 9.16069 7.82076 9.32945 7.77451 9.50584C7.70686 9.76382 7.675 10.0381 7.67788 10.3223C7.25916 10.318 6.81898 10.2383 6.37785 10.0865C5.74556 9.86899 5.11131 9.5035 4.53543 8.99998C5.11156 8.49634 5.7461 8.13084 6.37863 7.91344Z"
    fill="#E251A6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.91406 6.37754C7.7619 6.81904 7.68189 7.25962 7.67742 7.67873C7.2591 7.68302 6.81935 7.76259 6.37864 7.91406C6.08507 7.31327 5.89477 6.60635 5.84336 5.84305C6.60646 5.89425 7.31327 6.08429 7.91406 6.37754Z"
    fill="#C54197"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.49149 7.77431C8.23418 7.70711 7.9607 7.67549 7.6774 7.6784C7.67437 7.96207 7.70595 8.23591 7.7732 8.49355C7.81962 8.67141 7.88303 8.84155 7.96379 9.00186C7.88373 9.16097 7.82075 9.32974 7.77449 9.50612C7.70684 9.7641 7.67498 10.0384 7.67786 10.3225C7.96139 10.3255 8.23508 10.2938 8.49257 10.2265C8.66947 10.1802 8.83872 10.1172 8.99826 10.037C9.15856 10.1178 9.32869 10.1814 9.50655 10.2279C9.76414 10.2952 10.0379 10.3269 10.3216 10.324C10.3246 10.0394 10.2928 9.76472 10.2251 9.50634C10.1788 9.32955 10.1157 9.1604 10.0354 9.00096C10.1161 8.84078 10.1795 8.67079 10.226 8.49309C10.2933 8.23571 10.325 7.96214 10.3221 7.67874C10.039 7.67584 9.7657 7.70741 9.50856 7.7745C9.33064 7.82092 9.16044 7.88435 9.00007 7.96513C8.83968 7.88427 8.66945 7.82078 8.49149 7.77431Z"
    fill="#E251A6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.22991 9.28585C3.54036 9.9754 3.06269 10.7727 2.81625 11.5605C1.71519 10.9838 1 10.0514 1 8.99929C1 7.94724 1.71514 7.01486 2.81613 6.43809C3.06239 7.22661 3.54028 8.02461 4.2304 8.71473C4.32995 8.81428 4.43175 8.90941 4.53544 9.00007C4.43158 9.09086 4.32962 9.18614 4.22991 9.28585Z"
    fill="#C16CB6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.37786 10.0865C6.08473 10.687 5.89472 11.3933 5.84336 12.156C5.7058 12.1652 5.56641 12.1699 5.42548 12.1699C4.44979 12.1699 3.54784 11.9437 2.81625 11.5605C3.0627 10.7726 3.54036 9.97532 4.22991 9.28577C4.32962 9.18606 4.43158 9.09078 4.53544 8.99999C5.11132 9.50351 5.74557 9.86901 6.37786 10.0865Z"
    fill="#B551B4"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.42547 12.169C5.5664 12.169 5.70579 12.1643 5.84335 12.1551C5.83405 12.2931 5.8293 12.433 5.8293 12.5744C5.8293 13.5498 6.05536 14.4514 6.43835 15.1829C5.25183 15.5537 4.08666 15.4002 3.34266 14.6562C2.59846 13.912 2.44502 12.7464 2.81625 11.5595C3.54784 11.9428 4.44978 12.169 5.42547 12.169Z"
    fill="#A158C4"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.37784 10.0868C6.81897 10.2385 7.25915 10.3183 7.67787 10.3226C7.68211 10.7411 7.76173 11.1811 7.91333 11.6221C7.31269 11.9152 6.60615 12.1051 5.84334 12.1562C5.8947 11.3936 6.08472 10.6873 6.37784 10.0868Z"
    fill="#CA73D2"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.84335 12.1558C6.60616 12.1046 7.31271 11.9147 7.91335 11.6216C8.13073 12.254 8.49614 12.8883 8.9996 13.4643C8.90886 13.5681 8.81363 13.67 8.71398 13.7696C8.02416 14.4595 7.22655 14.9372 6.43835 15.1836C6.05537 14.4521 5.8293 13.5505 5.8293 12.5751C5.8293 12.4337 5.83406 12.2938 5.84335 12.1558Z"
    fill="#AA73DB"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.28553 13.7694C9.97544 14.4593 10.7732 14.9371 11.5615 15.1834C10.9847 16.2847 10.0522 17 9.00003 17C7.94769 17 7.0151 16.2845 6.43836 15.183C7.22655 14.9366 8.02416 14.4589 8.71399 13.769C8.81364 13.6694 8.90886 13.5675 8.99961 13.4637C9.09044 13.5676 9.18577 13.6696 9.28553 13.7694Z"
    fill="#916DCD"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.99958 13.4639C9.50317 12.8878 9.86867 12.2534 10.0861 11.6209C10.6869 11.9142 11.3936 12.1041 12.1567 12.1553C12.166 12.2934 12.1707 12.4333 12.1707 12.5747C12.1707 13.5502 11.9446 14.4521 11.5614 15.1836C10.7731 14.9373 9.97541 14.4595 9.2855 13.7696C9.18574 13.6698 9.09041 13.5678 8.99958 13.4639Z"
    fill="#9C78E4"
  />
  <path
    d="M9.00011 2.53711C9.00021 6.09382 11.9432 8.95657 15.4643 9.00127C11.8942 9.00133 9.00017 11.8954 9.00011 15.4654C9.00005 11.8954 6.10593 9.00138 2.53595 9.00127C6.10591 9.00115 9.00001 6.10707 9.00011 2.53711Z"
    fill="#E9E0F5"
  />
</svg>
